import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { AnnotationNavigationIconButton } from '../../../../../../modules/common/annotationNavigationButton/AnnotationNavigationIconButton';
import { EditorMode } from '../../../../../../modules/editor/models/EditorModes';
import { IClarificationsStore } from '../Clarifications.store';
import { IClarificationsBl } from '../services/Clarifications.bl';
import { RequestClarificationModalContainer } from './RequestClarificationModal.container';

interface IProps {
  editorMode: EditorMode;
  disabled?: boolean;
}

export const RequestClarificationButtonContainer = observer((props: IProps): ReactElement => {
  const { clarification } = useInjection(IClarificationsStore.$);
  const clarificationsBl = useInjection(IClarificationsBl.$);

  const { t } = useTranslator();
  const [showModal, setShowModal] = useState(false);

  const handleToggle = (): void => {
    setShowModal((prev) => !prev);
    clarificationsBl.setClarificationQuestion('');
  };

  const canShowRequestClarification = clarification === undefined || (clarification !== undefined && clarification.answer !== null);

  return (
    <>
      {canShowRequestClarification && (
        <AnnotationNavigationIconButton
          size='md'
          color='neutral'
          variant='outlined'
          loaderKey='request-clarification-button'
          title={t('clarifications.request_clarification_button_tooltip')}
          disabled={props.disabled ?? false}
          onClick={handleToggle}
        >
          <FontAwesomeIcon icon={faQuestionCircle} />
        </AnnotationNavigationIconButton>
      )}
      <RequestClarificationModalContainer
        showModal={showModal}
        onToggle={handleToggle}
        editorMode={props.editorMode}
      />
    </>
  );
});
